import { api } from '@/scripts/api';

export const CustomActivityTypeService = {

    getCustomTypes(queryParams) {
            

        return new Promise((resolve, reject) => {
            const service = `/Service/CustomActivityTypes${queryParams ? '?'+queryParams : ''}`;
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    createCustomType(body) {
        

        return new Promise((resolve, reject) => {
            const service = '/api/CustomActivityTypes';
            api
                .post(service, body)
                .then(resolve)
                .catch(reject);
        });
    },

    editCustomType(id, body) {
        var changes = [
            {
                name: 'Icon',
                value: body.Icon,
            },
            {
                name: 'IconColor',
                value: body.IconColor
            },
            {
                name: 'Name',
                value: body.Name
            }
        ];

        return new Promise((resolve, reject) => {
            const service = `/api/CustomActivityTypes/${id}`;
            api
            .patch(service, changes)
                .then(resolve)
                .catch(reject);
        })
    }

}